import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const ParameterModals = lazy(() => import(/* webpackChunkName: "ParameterModals" */ './components/ParameterModals'));

const parameterModal = document.querySelectorAll('.parameter-modal');
parameterModal.forEach((element) => {
    const props = parseDatasetToProps(element.dataset);

    render(
        <Suspense fallback={<></>}>
            <ParameterModals {...props}/>
        </Suspense>,
        element
    );
});
